import React, { useState, useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMessage,
  removeChat,
  activeConversation,
  updateMessageGroupStatus
} from '../../../../store/action/internalChat';

import { FormatDate } from '../formatDatePTBR';
import { FormatTime } from '../formatTIME';
import ReacScrollabelFeed from 'react-scrollable-feed';
import { Button } from 'reactstrap';
import { RiAttachment2 } from 'react-icons/ri';
import { MdClose } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoIosSend } from 'react-icons/io';
import { FaMicrophone } from 'react-icons/fa';
import { GroupOptionsButton, GroupOptionsButtonWhite } from '../../style';
import GroupUploadFileModal from '../modal/groupUploadFileModal';
import { FlexMediaPreviewerV2 } from '../flexMediaPreviewer v2';
import GroupAudioSender from '../audioSender/groupAudioSender';
import { BsCheck2, BsCheck2All } from 'react-icons/bs';
import { ObjectId } from 'bson';

import {
  Container,
  Header,
  BodyChat,
  BalloonRight,
  BalloonLeft,
  InputArea,
  ContentMessages,
  NotificationBadge,
  Loading,
  MessageStatusRight,
  MessageStatusLeft
} from './style';

import api from '../../config/configAPI';
import { useConectionSocketChatInternal } from 'hooks/useInternalChatSocket';
import { useGroupMembers } from '../../../../hooks/useGroupMembers';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

export const ChatGroup = forwardRef(
  ({ group = {}, unreadGroups = [], setUnreadGroups }) => {
    const dispatch = useDispatch();
    const systemConfiguration = useSelector(
      (state) => state.systemConfiguration
    );

    const [chatToggle, setChatToggle] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [loadingMessages, setLoadingMessages] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [isRecording, setIsRecording] = useState(false);

    const { socketInternalChat } = useConectionSocketChatInternal();
    const userLogin = localStorage.getItem('login');
    const { getMemberInfo, preloadMembers } = useGroupMembers();

    function modifyAcive(boll) {
      dispatch(activeConversation(chatToggle, boll));
      if (boll) {
        socketInternalChat.emit('chat:opened', {
          self: userLogin,
          partnerId: '',
          groupId: group.id
        });
        if (unreadGroups.includes(group.id)) {
          setUnreadGroups((prev) => prev.filter((g) => g !== group.id));
        }
      }
    }

    function closeChatSpecific(param) {
      const identifier = param?.login || param?.id;
      if (identifier) {
        dispatch(removeChat(identifier));
      }
    }

    async function getMessages(groupId) {
      try {
        setLoadingMessages(true);
        const response = await api.get(`/groups/messages/${groupId}`, {
          headers: {
            limit: 50,
            skip: 0
          }
        });

        const messages = response.data?.messages || [];

        const uniqueSenders = [...new Set(messages.map((msg) => msg.sender))];
        await preloadMembers(uniqueSenders);

        dispatch(addMessage(messages, groupId, null, false));
      } catch (err) {
        console.error('Erro ao carregar mensagens do grupo:', err);
      } finally {
        setLoadingMessages(false);
      }
    }

    const getStatusIcon = (message) => {
      const situation = message?.globalStatus;

      if (!situation) return null;

      switch (situation) {
        case 'sent':
          return <BsCheck2 size={16} color="#9e9e9e" />;
        case 'received':
          return <BsCheck2All size={16} color="#9e9e9e" />;
        case 'read':
          return <BsCheck2All size={16} color="#1d9bf0" />;
        default:
          return null;
      }
    };

    const enviarMensagem = (e) => {
      e.preventDefault();
      if (!mensagem.trim() || !group?.id) return;

      const mensagemId = new ObjectId().toHexString();

      const dataSendMessage = {
        groupId: group.id,
        sender: userLogin,
        content: mensagem,
        mensagemId: mensagemId
      };

      socketInternalChat.emit('group:message_send', dataSendMessage);

      setMensagem('');
    };

    useEffect(() => {
      const handleGroupMessage = (dados) => {
        const isFile = !!dados.source;

        const mensagemFormatada = {
          content: dados.content || '',
          sender: dados.sender,
          createdAt: dados.createdAt || new Date().toISOString(),
          globalStatus: dados.globalStatus || 'sent',
          statusByUser: dados.statusByUser || [],
          id: dados.messageId,
          ...(isFile && {
            type: 'file',
            source: dados.source
          })
        };

        if (dados.groupId === group?.id) {
          getMemberInfo(dados.sender);

          dispatch(
            addMessage(
              mensagemFormatada,
              group.login || group.id,
              dados.sender,
              true,
              dados.messageId,
              true
            )
          );
        }

        if (dados.groupId === group?.id && chatToggle?.active) {
          if (unreadGroups.includes(group.id)) {
            setUnreadGroups((prev) => prev.filter((g) => g !== group.id));
          }
        }
      };

      socketInternalChat.on('group:message', handleGroupMessage);
      socketInternalChat.on('group:message_receive', handleGroupMessage);

      return () => {
        socketInternalChat.off('group:message', handleGroupMessage);
        socketInternalChat.off('group:message_receive', handleGroupMessage);
      };
    }, [group, getMemberInfo]);

    useEffect(() => {
      const handleStatusChange = (updatedMessage) => {
        if (
          updatedMessage.groupId === group.id &&
          updatedMessage.sender === localStorage.getItem('login')
        ) {
          dispatch(
            updateMessageGroupStatus(
              updatedMessage.groupId,
              updatedMessage.id,
              updatedMessage.statusByUser,
              updatedMessage.globalStatus,
              localStorage.getItem('login')
            )
          );
        }
      };

      socketInternalChat.off('change:statusGroupMessage', handleStatusChange);
      socketInternalChat.on('change:statusGroupMessage', handleStatusChange);

      return () => {
        socketInternalChat.off('change:statusGroupMessage', handleStatusChange);
      };
    }, [group.id, group.login, socketInternalChat]);

    useEffect(() => {
      if (group?.id) getMessages(group.id);
      if (group) setChatToggle(group);
    }, [group]);

    if (!group?.id) {
      return null;
    }

    return (
      <Container>
        <Header
          color={systemConfiguration.primary_color}
          fontColor={systemConfiguration.internal_chat_font_color}
        >
          <button
            className="header"
            onClick={() => modifyAcive(!chatToggle.active)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {group?.name || 'Sem Nome'}
              {unreadGroups.includes(group.id) && <NotificationBadge />}
            </span>
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {chatToggle?.active ? (
              <GroupOptionsButtonWhite
                title="Opções do grupo"
                onClick={(e) => {
                  e.stopPropagation();
                  window.dispatchEvent(
                    new CustomEvent('internalchat:group:options', {
                      detail: { groupId: group.id, group }
                    })
                  );
                }}
              >
                <BsThreeDotsVertical size={18} />
              </GroupOptionsButtonWhite>
            ) : (
              <GroupOptionsButton
                title="Opções do grupo"
                onClick={(e) => {
                  e.stopPropagation();
                  window.dispatchEvent(
                    new CustomEvent('internalchat:group:options', {
                      detail: { groupId: group.id, group }
                    })
                  );
                }}
              >
                <BsThreeDotsVertical size={18} />
              </GroupOptionsButton>
            )}
            <MdClose
              size="21"
              color="white"
              type="button"
              onClick={() => {
                closeChatSpecific(group);
                socketInternalChat.emit('group:closed', {
                  self: userLogin,
                  groupId: group.id
                });
              }}
            />
          </div>
        </Header>

        <BodyChat size={chatToggle?.active}>
          {loadingMessages ? (
            <Loading>
              <div className="spinner" />
            </Loading>
          ) : (
            <ReacScrollabelFeed forceScroll className="area-messages">
              {group?.messages?.map((message, index) => {
                const isSender = userLogin === message.sender;
                const memberInfo = getMemberInfo(message.sender);

                const showDate =
                  index === 0 ||
                  new Date(group.messages[index]?.createdAt).getDate() !==
                    new Date(group.messages[index - 1]?.createdAt).getDate();

                return (
                  <div key={index}>
                    {showDate && <FormatDate date={message.createdAt} />}

                    <ContentMessages
                      align={isSender ? 'flex-end' : 'flex-start'}
                    >
                      {isSender ? (
                        <BalloonRight>
                          {message.type === 'file' ? (
                            <FlexMediaPreviewerV2
                              fileURL={message.content || message.source}
                            />
                          ) : (
                            message.content
                          )}
                          <MessageStatusRight>
                            <FormatTime
                              paramAlign="right"
                              date={message.createdAt}
                            />
                            {getStatusIcon(message)}
                          </MessageStatusRight>
                        </BalloonRight>
                      ) : (
                        <BalloonLeft
                          fontColor={
                            systemConfiguration.internal_chat_font_color
                          }
                          color={
                            systemConfiguration.internal_chat_balloon_color
                          }
                        >
                          <div
                            style={{
                              fontSize: '12px',
                              fontWeight: '600',
                              color: '#666',
                              marginBottom: '4px',
                              textAlign: 'left'
                            }}
                          >
                            {memberInfo.name}
                          </div>
                          {message.type === 'file' ? (
                            <FlexMediaPreviewerV2
                              fileURL={message.content || message.source}
                            />
                          ) : (
                            message.content
                          )}
                          <MessageStatusLeft>
                            <FormatTime
                              paramAlign="left"
                              date={message.createdAt}
                            />
                          </MessageStatusLeft>
                        </BalloonLeft>
                      )}
                    </ContentMessages>
                  </div>
                );
              })}
            </ReacScrollabelFeed>
          )}
        </BodyChat>

        <InputArea size={chatToggle?.active} onSubmit={enviarMensagem}>
          {!isRecording ? (
            <form
              onSubmit={enviarMensagem}
              className="form-chat-internal"
              style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <input
                type="text"
                name="mensagem"
                value={mensagem}
                autoComplete="off"
                onChange={(e) => setMensagem(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    enviarMensagem(e);
                  }
                }}
                className="input-chat-internal-write"
                placeholder="Digite uma mensagem"
              />

              <div className="chat-buttons">
                {mensagem && mensagem.length > 0 ? (
                  <>
                    <input
                      style={{ display: 'none' }}
                      type="submit"
                      id="inputSendMessage"
                      onSubmit={(e) => {
                        e.preventDefault();
                        enviarMensagem(e);
                      }}
                    />
                    <Button
                      type="submit"
                      className="shadow-none"
                      style={buttonStyle(systemConfiguration.primary_color)}
                      size="sm"
                      title="Enviar mensagem"
                    >
                      <IoIosSend
                        size={18}
                        color="#ffffff"
                        onClick={(e) => {
                          e.preventDefault();
                          enviarMensagem(e);
                        }}
                      />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className="shadow-none"
                      color="link"
                      size="sm"
                      title="Gravar áudio"
                      onClick={() => setIsRecording(true)}
                    >
                      <FaMicrophone size={20} color="#676666ff" />
                    </Button>
                    <Button
                      className="shadow-none"
                      color="grey"
                      size="sm"
                      title="Enviar arquivo"
                      onClick={() => setShowUploadModal(true)}
                    >
                      <RiAttachment2 size={22} />
                    </Button>
                  </>
                )}
              </div>
            </form>
          ) : (
            <GroupAudioSender
              groupId={group.id}
              sender={userLogin}
              setIsRecording={setIsRecording}
              isRecording={isRecording}
            />
          )}
        </InputArea>

        <GroupUploadFileModal
          isOpen={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          groupId={group.id}
          sender={userLogin}
        />
      </Container>
    );
  }
);

ChatGroup.displayName = 'ChatGroup';
